import React from 'react';
import { VERSION } from '../config';
import '../mobile.css';

const AppFooter = ({ loading }) => {
  return (
    <div className="m-footer">
      {loading ? (
        <div className="m-marquee-wrapper">
          <p className="m-footer-text">AI Agent is analyzing FIR.</p>
          <div className="m-marquee-track">
            <span className="m-marquee-text">Please wait...</span>
          </div>
        </div>
      ) : (
        <>
          <p className="m-footer-text">LegalApp AI Assistant</p>
          <p className="m-footer-text-small">Verify the information before taking action.</p>
        </>
      )}
    </div>
  );
};

export default AppFooter;
